<template>
	<div class="d-inline">
		<template v-if="showSelection" :key="i">
			<v-chip v-for="(u, i) in selected">
				{{ u.name }}({{ u.id }})
				<v-btn @click="unselect(i)" text color="error"><v-icon>$delete</v-icon></v-btn>
			</v-chip>
		</template>
		<span @click="show = true">
			<slot>
				<v-btn color="primary" dark class="d-inline-block mr-2">请选择收款账户</v-btn>
			</slot>
		</span>
		<v-dialog v-model="show">
			<v-card>
				<v-card-title class="d-flex justify-space-between">
					请选择收款账户
					<v-spacer />
					<v-icon @click="show = false">$close</v-icon>
				</v-card-title>

				<v-card-text cols="12" class="text-center">
					<AccountList>
						<template #actions="{ ca, selected, selectedIds }">
							<v-btn class="ml-2 mt-2" @click="select(ca)" color="primary" outlined>选择</v-btn>
						</template>
					</AccountList>
				</v-card-text>
				<v-card-actions v-if="multiple">
					<v-btn @click="confirm11" class="primary">确定</v-btn>
					<v-btn @click="cancel">取消</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import AccountList from './AccountList.vue'

export default {
	name: 'AccountSelector',
	components: {
		AccountList
	},
	emits: ['selected'],
	props: {
		// shopId: { type: [Number, String], default: null },
		showSelection: { type: Boolean, default: false },
		value: { type: Array, default: () => [] } //初始选择（之前已经选择）
	},
	data() {
		return {
			selected: [],
			show: false
		}
	},
	mounted() {
		if (this.value && this.value.length > 0) {
			let ids = this.value.join(',')
			this.load(ids)
		}
	},
	watch: {
		value(nv, ov) {
			// console.log('shopselector watch value', nv, ov)
			if (nv && nv.length > 0) {
				let ids = nv.join(',')
				let oids = ov.join(',')
				// console.log(ids, oids)
				if (ids !== oids) {
					this.load(ids)
				}
			}
		}
	},
	computed: {
		selectedIds() {
			return this.selected.map((e) => e.id)
		}
	},
	methods: {
		load(ids) {
			this.$api.shop.getAccountById(ids, (r) => {
				for (var i = 0; i < r.length; i++) {
					this.addToSelected(r[i])
				}
			})
		},
		addToSelected(o) {
			let eindex = this.selected.findIndex((e) => e.id === o.id)
			if (eindex < 0) this.selected.push(o)
		},
		confirm11() {
			this.show = false
			this.$emit('selected', this.selectedIds, this.selected)
		},
		select(item) {
			if (this.multiple) {
				this.addToSelected(item)
			} else {
				this.selected = []
				this.addToSelected(item)
				this.confirm11()
			}
		},
		unselect(idx) {
			if (this.multiple) {
				this.selected.splice(idx, 1)
			} else {
				this.selected = []
			}
		},

		cancel() {
			this.show = false
		}
	}
}
</script>
